import React from "react"

export const SaveAsDraftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_1571_10319)">
            <path
                d="M14.6663 4.00065V13.8673C14.6663 14.3091 14.3082 14.6673 13.8663 14.6673H2.13301C1.69118 14.6673 1.33301 14.3091 1.33301 13.8673V2.13398C1.33301 1.69216 1.69118 1.33398 2.13301 1.33398H11.9997L14.6663 4.00065Z"
                stroke="#1F1C37"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.8 6.66732H10.6667C11.1085 6.66732 11.4667 6.30915 11.4667 5.86732V1.33398H4V5.86732C4 6.30915 4.35817 6.66732 4.8 6.66732Z"
                stroke="#1F1C37"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9.86647 2.40039H8.7998V5.60039H9.86647V2.40039Z" stroke="#1F1C37" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.5335 8.26758H3.4668V14.6676H12.5335V8.26758Z" stroke="#1F1C37" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1571_10319">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
